"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const image_1 = require("../../utils/image");
function mapToVideoProps({ data }) {
    let media;
    let posterUrl;
    if (!('blockType' in data)) {
        media = data;
    }
    else if (data.mediaReference && typeof data.mediaReference === 'object') {
        media = data.mediaReference;
        if ('poster' in data && data.poster && typeof data.poster === 'object') {
            posterUrl = (0, image_1.getMediaUrl)(data.poster);
        }
    }
    return {
        url: media && (0, image_1.getMediaUrl)(media),
        poster: posterUrl,
        iframe: 'iframe' in data && typeof data.iframe === 'string' ? data.iframe : undefined,
        width: 'width' in data && data.width && typeof data.width === 'string' ? data.width : undefined,
        height: 'height' in data && data.height && typeof data.height === 'string' ? data.height : undefined,
    };
}
exports.default = mapToVideoProps;
